import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { environment } from "../../../environments/environment";
import { KpiService } from "../../kpi/kpi.service";
import { TIERS } from "../../constants";

@Component({
  selector: "settings-nav",
  templateUrl: "./settings-nav.component.html",
  styleUrls: ["./settings-nav.component.scss"],
})
export class SettingsNavComponent implements OnInit {
  @Input() pageTitle;
  @Input() settingsNavItemData;
  @Output() navItemClicked = new EventEmitter();

  partialImagePath: string = "../../assets/images/";
  isStarterUser: boolean;

  constructor(private kpiService: KpiService) {}

  ngOnInit() {
    this.kpiService.getUserInfo().subscribe((data) => {
      this.isStarterUser = data.sz_tier == TIERS.STARTER.key;
    });
  }

  getFullImagePath(icon) {
    return this.partialImagePath + icon + ".png";
  }

  navClicked(event) {
    this.navItemClicked.emit(event);
  }

  goToAddUser() {
    window.open(`${environment.szAppHostname}/share`, "_blank");
  }
}
